import FRAMEWORKS from "./frameworks.js";
import { getDefaultProviderComplianceFrameworks } from "../utils/providerFrameworks.js";

const BASELINE_ID = "OKTA-BASELINE";

function displayFor(id) {
  const d = FRAMEWORKS[String(id)];
  return d?.displayName || d?.name || String(id);
}

/**
 * @param {string[]|null|undefined} selected
 * @param {string} [providerId]
 * @returns {string}
 */
export function formatComplianceScopeDisplay(selected, providerId = "okta") {
  const fallback = getDefaultProviderComplianceFrameworks(providerId)[0] || BASELINE_ID;
  const sel =
    Array.isArray(selected) && selected.length
      ? [...new Set(selected.map((x) => String(x)).filter(Boolean))]
      : [fallback];
  const hasBaseline = sel.includes(BASELINE_ID);
  const composed = Array.isArray(FRAMEWORKS[BASELINE_ID]?.composedOf)
    ? FRAMEWORKS[BASELINE_ID].composedOf.map(String)
    : [];
  const composedSet = new Set(composed);

  if (hasBaseline) {
    const others = sel.filter((id) => id !== BASELINE_ID && !composedSet.has(id));
    const inner = composed.map(displayFor).join(", ");
    const baselinePart = `${displayFor(BASELINE_ID)} (${inner})`;
    if (!others.length) return baselinePart;
    return `${others.map(displayFor).join(", ")} + ${baselinePart}`;
  }

  return sel.map(displayFor).join(", ");
}
